<template lang="pug">
breadcrumbs-layout(:breadcrumbs='breadcrumbs', :wide='true')
  map-notification(v-if='points && points.length < filtered && limited') Количество отображаемых на карте объектов ограничено.
    template(slot='small') Отображение всех объектов может существенно повлиять на скорость работы сайта!
    ext-button(
      size='small',
      slot='action',
      :factor='1.2',
      :fill='false',
      :to='unlimitedRoute'
    ) Показать все
  map-page-layout(
    :points='hasCoords',
    :filtered='filtered',
    :updateEvents='updateEvents'
  )
    filter-yellow(
      slot='filter',
      route='map',
      :key='JSON.stringify(filterValues)',
      :fields='filterFields',
      :values='filterValues',
      :nav='navSwitcher'
    )
</template>

<script>
import ExtButton from '@/components/ext/Button.vue';
import MapPageLayout, {
  Notification as MapNotification,
} from 'elysium-common/components/page/map';
import TransitionFade from '@/components/transition/Fade.vue';
import { Breadcrumbs as BreadcrumbsLayout } from 'elysium-common/components/layout';
import { Filter as FormFilter } from 'elysium-common/components/parts/form';
import { Yellow as FilterYellow } from 'elysium-common/components/parts/filter';

import mixin from '../mixin.js';
import mixinList from '../mixin-list.js';
import checkPfdod from '@/mixins/isPfdodCheck';
import mixinFilter from '../../mixin-filter.js';

const LIMIT_DEFAULT = 350;
const UNLIMITED_VALUE = 'yes';

const convertRoute = (route, unlimited) => {
  const { name, params } = route;
  const query = { ...route.query };
  if (unlimited) {
    query.unlimited = UNLIMITED_VALUE;
  } else if (query.unlimited !== undefined) {
    delete query.unlimited;
  }
  return { name, params, query };
};

export default {
  limitDefault: LIMIT_DEFAULT,
  inject: ['$api'],
  mixins: [mixin, mixinList, mixinFilter, checkPfdod],
  components: {
    ExtButton,
    MapNotification,
    MapPageLayout,
    BreadcrumbsLayout,
    TransitionFade,
    FormFilter,
    FilterYellow,
  },
  props: {
    unlimited: {
      type: String,
      validator(value) {
        return [undefined, UNLIMITED_VALUE].includes(value);
      },
    },
  },
  beforeMount() {
    this.getEvents();
  },
  data() {
    return {
      filtered: 0,
      points: false,
      name: 'На карте',
      link: 'map',
    };
  },
  computed: {
    hasCoords() {
      return this.points
        ? this.points.filter((point) => Array.isArray(point.coords))
        : [];
    },

    coords() {
      return (
        (this.points && this.points[0] && this.points[0].coords) ||
        DEFAULT_COORDS
      );
    },

    limited() {
      return this.unlimited !== UNLIMITED_VALUE;
    },

    unlimitedRoute() {
      return convertRoute(this.$route, true);
    },

    navSwitcher() {
      return this.$options.filterNav.map((item, index) => {
        const selected =
          item.variant === 'catalog'
            ? ['events', 'home'].includes(this.$route.name)
            : this.$route.name === 'map';
        return { ...item, selected };
      });
    },
  },
  watch: {
    $route() {
      this.getEvents();
    },
  },
  methods: {
    getEvents() {
      this.points = false;
      const {
        age,
        is_pfdod,
        disease,
        municipality,
        municipality_region_id,
        organizer,
        region,
        section,
        subsection,
      } = this;
      const term = this.$route.query.term || '';
      const params = {
        age,
        is_pfdod,
        disease,
        municipality,
        organizer,
        region,
        section,
        subsection,
        term,
      };
      let func = (params) => {
        return this.$api.get('events/map', { params });
      };
      this.$util
        .getDataLoop(
          {
            ...params,
            limit: 1000,
          },
          'filtered',
          func
        )
        .then((dataArr) => {
          this.points = dataArr.flatMap(({ id, name, coordinates }) => {
            return coordinates.map(({ lat, lng, location }) => {
              return {
                id: Number(id),
                title: name,
                coords: lat && lng ? [lat, lng] : false,
                uniqId: `${id}-${name}-${lat}-${lng}`
              };
            });
          });
        })
        .catch((err) => (this.points = []));
    },

    updateEvents(ids) {
      const promiseArr = ids.map(this.updateEvent);
      return Promise.all(promiseArr);
    },

    updateEvent(id) {
      const index = this.points.findIndex((element, index) => element.id == id);
      if (index === -1 || this.points[index].__UPDATED__) {
        return;
      }
      return this.$api
        .get(`event/get/${id}`)
        .then((res) => {
          const data = res.data.data;
          data.__UPDATED__ = true;
          return data;
        })
        .catch((err) => {
          // console.log(err);
        });
    },
  },
  beforeRouteUpdate(to, from, next) {
    // Если в предыдущем хите был установлен флаг неограниченного количества
    if (
      from.name === to.name &&
      from.query.unlimited !== to.query.unlimited &&
      from.query.unlimited === UNLIMITED_VALUE
    ) {
      next(convertRoute(to, true));
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    // Убираем флаг безлимитности
    if (to.query.unlimited === UNLIMITED_VALUE) {
      next(convertRoute(to, false));
    } else {
      next();
    }
  },
};
</script>



// WEBPACK FOOTER //
// Map.vue?3b706401